import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardListIcon, HomeIcon, UserCheckIcon, SmartphoneIcon, RefreshCwIcon, ClockIcon } from 'lucide-react';
const features = [{
  icon: ClipboardListIcon,
  text: '+100 planillas listas para usar'
}, {
  icon: UserCheckIcon,
  text: 'Evaluaciones completas por patología'
}, {
  icon: RefreshCwIcon,
  text: 'Evolución y seguimiento personalizado'
}, {
  icon: SmartphoneIcon,
  text: 'Informes claros y organizados'
}, {
  icon: HomeIcon,
  text: 'Formatos Excel, Sheets, Word y PDF'
}, {
  icon: ClockIcon,
  text: '100% editables e imprimibles'
}];
export function ProductReveal() {
  return <section className="py-14 md:py-24 bg-brand-dark text-white overflow-hidden" data-id="element-274">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-275">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14" data-id="element-276">
          <h2 className="text-4xl md:text-5xl font-extrabold mb-4" data-id="element-277">
            MEGAPACK KINESIO PRO
          </h2>
          <p className="text-base md:text-xl text-slate-300" data-id="element-278">
            El sistema definitivo de planillas de informes profesionales para
            kinesiólogos
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-6" data-id="element-279">
          {features.map((feature, index) => <div key={index} className="bg-slate-800/40 p-4 md:p-6 rounded-xl border border-slate-700/50 flex flex-col items-center text-center gap-2 md:gap-4 hover:bg-slate-800/60 transition-colors" data-id="element-280">
              <div className="bg-brand-accent/10 p-2.5 md:p-4 rounded-full" data-id="element-281">
                <feature.icon className="w-5 h-5 md:w-8 md:h-8 text-brand-accent" data-id="element-282" />
              </div>
              <p className="text-xs md:text-base font-medium text-slate-200 leading-snug" data-id="element-283">
                {feature.text}
              </p>
            </div>)}
        </motion.div>
      </div>
    </section>;
}